import { Box, Card, Text, Title } from '@nimbus-ds/components';
import type { ReactElement } from 'react';

/**
 * Pantalla para cuando el handshake de Nexo no contesta.
 *
 * En la práctica significa una de dos cosas: alguien abrió esta URL suelta en el
 * navegador, o el iframe cargó pero el admin no respondió. Para el comerciante son el
 * mismo problema y tienen la misma salida, así que no vale la pena distinguirlas: lo que
 * necesita saber es por dónde se entra.
 *
 * Sin esto la app se quedaba en blanco, que es la peor forma de fallar: no dice nada.
 */
export function FueraDelAdmin(): ReactElement {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      padding="6"
      backgroundColor="neutral-background"
    >
      <Box maxWidth="32rem" width="100%">
        <Card>
          <Card.Body>
            <Box display="flex" flexDirection="column" gap="3">
              <Title as="h1" fontSize="h3">
                Precios al día se abre desde el panel de tu tienda
              </Title>
              <Text>
                Entrá al administrador de Tienda Nube, abrí <strong>Aplicaciones</strong> en el menú
                y elegí Precios al día desde ahí.
              </Text>
              <Text fontSize="caption" color="neutral-textLow">
                La app trabaja con los precios de tu tienda, así que necesita abrirse adentro del
                panel para saber de qué tienda se trata.
              </Text>
            </Box>
          </Card.Body>
        </Card>
      </Box>
    </Box>
  );
}
